export default "__VITE_ASSET__DG2QC$Eo__"